/* eslint no-param-reassign: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import Checkbox from 'react-toolbox/lib/checkbox';

import {
  available as getAvailable,
  active as getActive,
  start,
  finish
} from '~/actions/work';
import Title from '~/components/Title';
import Tag from '~/components/Tag';

import Styles from './widget.scss';

class Pickup extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitting: false,
      expandedOrders: {},
      available: [],
      active: [],
      availableSelected: {},
      activeSelected: {},
      availableErrors: {},
      activeErrors: {}
    };
  }

  componentDidMount() {
    this.fetchInterval = setInterval(this.fetchWork.bind(this), 300000);
    this.fetchWork();
  }

  componentWillUnmount() {
    if (this.fetchInterval) {
      clearInterval(this.fetchInterval);
    }
  }

  onPickedUpClick() {
    const promises = [];

    this.setState({ submitting: true });

    this.state.active.forEach(work => {
      if (this.state.activeSelected[work.id]) {
        promises.push(
          finish(this.props.dispatch, this.context.apiClient, work.id).catch(
            err =>
              this.setState({
                activeErrors: {
                  ...this.state.activeErrors,
                  [work.id]: err.error
                }
              })
          )
        );
      }
    });
    this.state.available.forEach(work => {
      if (this.state.availableSelected[work.containerId]) {
        promises.push(
          start(
            this.props.dispatch,
            this.context.apiClient,
            this.props.indata.actionId,
            work
          )
            .then(r =>
              finish(
                this.props.dispatch,
                this.context.apiClient,
                r.data.work.id
              )
            )
            .catch(err =>
              this.setState({
                availableErrors: {
                  ...this.state.availableErrors,
                  [work.containerId]: err.error
                }
              })
            )
        );
      }
    });
    Promise.all(promises)
      .then(() => {
        this.fetchWork();
        this.setState({ submitting: false });
      })
      .catch(() => {
        this.fetchWork();
        this.setState({ submitting: false });
      });
  }

  onActiveCheck(workId, checked) {
    this.setState({
      activeSelected: {
        ...this.state.activeSelected,
        [workId]: checked
      }
    });
  }

  onAvailableCheck(containerId, checked) {
    this.setState({
      availableSelected: {
        ...this.state.availableSelected,
        [containerId]: checked
      }
    });
  }

  fetchWork() {
    this.setState({ loading: true });
    Promise.all([
      getAvailable(this.props.dispatch, this.context.apiClient).then(r =>
        this.setState({ available: r.data[this.props.indata.actionId] })
      ),
      getActive(this.props.dispatch, this.context.apiClient).then(r =>
        this.setState({ active: r.data })
      )
    ])
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  toggleAll(checked) {
    if (checked) {
      this.setState({
        activeSelected: this.state.active.reduce(
          (obj, w) => ({ ...obj, [w.id]: true }),
          {}
        ),
        availableSelected: this.state.available.reduce(
          (obj, w) => ({ ...obj, [w.containerId]: true }),
          {}
        )
      });
    } else {
      this.setState({ activeSelected: {}, availableSelected: {} });
    }
  }

  renderQr() {
    return (
      <div className={Styles.qrContainer}>
        <img
          alt="QR code for scanner"
          src={`https://migration-api.sherpasystems.net/pdf/qrget/qr.png?content=${encodeURI(
            JSON.stringify({
              action: 'pickup',
              data: '' // todo
            })
          )}`}
        />
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    const {
      submitting,
      active,
      available,
      activeSelected,
      availableSelected
    } = this.state;
    const { showQr, title, hideButtons } = this.props.indata;
    const containerCount = active.length + available.length;
    return (
      <div className={`${this.props.className} ${Styles.widget}`}>
        <h5 className={Styles.title}>{title}</h5>
        <div className={Styles.content}>
          {submitting && <div>Submitting pickups, please wait...</div>}
          {!submitting && (
            <div>
              <div className={Styles.countContainers}>
                <div className={Styles.countContainer}>
                  <span className={Styles.count}>
                    {containerCount} container{containerCount === 1 ? '' : 's'}
                  </span>{' '}
                  ready to be picked up
                </div>
              </div>
              {!hideButtons && (
                <div className={Styles.buttons}>
                  <Button
                    label="Mark as picked up"
                    accent
                    raised
                    onClick={() => this.onPickedUpClick()}
                  />
                  <Button
                    label="Select all"
                    accent
                    raised
                    onClick={() => this.toggleAll(true)}
                  />
                  <Button
                    label="Deselect all"
                    accent
                    raised
                    onClick={() => this.toggleAll(false)}
                  />
                </div>
              )}
              <div className={Styles.contentRow}>
                <div className={Styles.orders}>
                  <Title>Active</Title>
                  {active.map(work => {
                    const { containerId } = work.data;
                    const selected = activeSelected[work.id];
                    const container = this.props.containers.get(containerId);
                    const orderId = container && container.get('orderId');
                    const error = this.state.activeErrors[containerId];
                    return (
                      <div className={Styles.orderContainer} key={work.id}>
                        <div className={Styles.order}>
                          <Checkbox
                            className={Styles.orderCheckbox}
                            checked={selected}
                            onChange={val => this.onActiveCheck(work.id, val)}
                          />
                          <Tag type="container" id={containerId} />
                          {orderId && <Tag type="order" id={orderId} />}
                          {/* <div className={Styles.boxes}>
                            <div className={Styles.boxToggler} />
                          </div> */}
                          {error && (
                            <div className={Styles.orderError}>{error}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <div className="clear" />
                  <Title>Available</Title>
                  {available.map(work => {
                    const { containerId } = work;
                    const selected = availableSelected[containerId];
                    const container = this.props.containers.get(containerId);
                    const orderId = container && container.get('orderId');
                    const error = this.state.availableErrors[containerId];
                    return (
                      <div className={Styles.orderContainer} key={containerId}>
                        <div className={Styles.order}>
                          <Checkbox
                            className={Styles.orderCheckbox}
                            checked={selected}
                            onChange={val =>
                              this.onAvailableCheck(containerId, val)
                            }
                          />
                          <Tag type="container" id={containerId} />
                          {orderId && <Tag type="order" id={orderId} />}
                          {error && (
                            <div className={Styles.orderError}>{error}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {showQr && this.renderQr()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  containers: state.getIn(['containers', 'items'])
});

// Setting pure: false is required for react router to work
export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(Pickup);



// WEBPACK FOOTER //
// ./app/widgets.new/Pickup/widget.js